import { createContext } from 'react';

type FeedContextType = {
	feedSessionId: string | null;
};

export const FeedContext = createContext<FeedContextType>({
	feedSessionId: null,
});
